import { Theme } from '@mui/material';

export const eventDetailsStyles = (theme: Theme) => ({
	root: {
		width: { xs: '100%', md: '320px' },
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},
	eventInfo: {
		p: '24px',
		gap: '27px',
		display: 'flex',
		position: 'relative',
		backgroundColor: `#00000066`,
		alignItems: 'center',

		'&:before': {
			content: '""',
			position: 'absolute',
			inset: 0,
			borderRadius: '8px 8px 0 0',
			border: '2px solid transparent',
			background: 'linear-gradient(162.26deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 91.05%) border-box',
			mask: 'linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0)',
			maskComposite: 'exclude',
			pointerEvents: 'none',
		}
	},
	eventBackground: {
		minWidth: '70px',
		maxWidth: '70px',
		minHeight: '70px',
		maxHeight: '70px',
		borderRadius: '4px',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		backgroundSize: 'cover',
	},
	orderSummary: {
		padding: '24px 12px',
		borderRadius: '0 0 8px 8px',
		backgroundColor: '#0000004D',
		position: 'relative',
		userSelect: 'none',
		overflow: 'hidden',
		flex: '0 1 auto',
	},
	eventName: {
		fontFamily: 'Montserrat',
		fontSize: '16px',
		fontWeight: 700,
		lineHeight: '24px',
		color: '#FFFFFF',
	},
	editTiersButton: {
		position: 'absolute',
		right: '13px',
		top: 0,
		transform: 'translateY(-50%)',
		padding: '5px 13px',
		border: `0.76px solid #FFFFFF4D`,
		backgroundColor: `#0000004D`,
		fontFamily: 'Montserrat',
		fontSize: '11px',
		fontWeight: 500,
		lineHeight: '16px',
		borderRadius: '25px',
		gap: '4px',
		color: '#FFFFFF',

		"& >svg": {
			width: '10px',
			height: '10px',
		},

		"&:hover": {
			backgroundColor: `#0000004D`,
		},

		"&:disabled": {
			color: '#FFFFFF',
			opacity: 0.2,
		}
	},
	eventDate: {
		flex: 1,
		color: '#FFFFFFCC',
		fontFamily: 'General Sans, sans-serif',
		fontSize: '14px',
		fontWeight: 600,
		lineHeight: '18px',
	},
	reservationTimer: {
		color: '#FFFFFFCC',
		fontFamily: 'Montserrat',
		fontSize: '12px',
		fontWeight: 500,

		'& span': {
			color: '#FFFFFF',
		}
	},
});
